<template>
  <div>
    <h1 class="text-center">
      {{ schema.$title }}
    </h1>

    <panel>
      <div class="row form-group">
        <w-input class="col-md-8" :model="schema.data.school.schoolName" :disabled="true" />

        <w-input class="col-md-4" :model="schema.data.schoolYear" />
      </div>
    </panel>

    <panel>
      <student :schema="schema" />
    </panel>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import Panel from '@/components/panel/Panel';
import { ow003PrezydenckiMixin } from '@/mixins/document/ow003Prezydencki';
import { replacePlaceholdersMixin } from '@/mixins/replacePlaceholders';

import Student from '../Student';

// @vuese
// Formularz wzoru OW-003-Prezydencki
export default {
  components: { Panel, Student, ...components },
  mixins: [ow003PrezydenckiMixin, replacePlaceholdersMixin],
  props: {
    // schema dokumentu
    schema: { type: Object, required: true }
  }
};
</script>
